<template>
	<div class="research">
		<div class="bg_box">
			<div class="content_box">
				<h1 class="title">研发背景</h1>
				<h2 class="en_title">TECHNICAL SUPPORT</h2>
				<p class="desc">科飞系列产品所应用的视知觉学习技术来自中国科学技术大学视觉研究实验室。公司依托中科大视觉研究实验室、中国科学院脑功能与脑疾病重点实验室和中国科学技术大学先进技术研究院，致力于国际最先进科研成果的转化工作，拥有着视知觉领域国际领先的核心技术。视觉研究实验室在大脑视皮层功能损伤机制和恢复途径方面进行了多年的探索和研究，曾获得国家基金委重点项目、国家基金委中—加合作项目、中科院重要方向项目的资助 ，发表相关SCI论文200余篇。相关成果曾被中央电视台、《纽约时报》等国内外媒体广泛报导。科飞在发展的过程中，也与国内外各高校和高科技型企业合作，促进技术和产品的不断发展。</p>
				<!-- 轮播 -->
				<div class="swiper_box">
					<i class="prev" @click="handlePrevClick"></i>
					<i class="next" @click="handleNextClick"></i>
					<div class="swiper-container" style="height: 100%;">
						<div class="swiper-wrapper">
							<div class="swiper-slide">
								<div class="img">
									<img src="../../../../assets/technical_support_01.jpg" alt="">
								</div>
								<div class="img">
									<img src="../../../../assets/technical_support_02.jpg" alt="">
								</div>
							</div>
							<div class="swiper-slide">
								<div class="img">
									<img src="../../../../assets/technical_support_03.jpg" alt="">
								</div>
								<div class="img">
									<img src="../../../../assets/technical_support_04.png" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 轮播 end -->
				
				<!-- 科飞视觉 -->
				<div class="kf">
					<div class="kf_img">
						<img src="../../../../assets/kf_img.png" alt="">
					</div>
					<h1 class="kf_name">科飞视觉</h1>
					<p class="kf_desc">合肥科飞视觉科技有限公司（简称“科飞视觉”）是高科技新型医疗服务企业，致力于视觉领域内高科技成果的转化和应用，努力为用户提供优质高效的视觉康复服务。公司坚持走产学研协同发展之路，与中科大视觉研究实验室、中科院脑功能与脑疾病重点实验室、中科大先进技术研究院等均有紧密的合作关系。科飞致力于实现“科技造福人类健康”的理想，与所有合作伙伴们一起为人类的视觉健康奋斗！</p>
				</div>
				<!-- 科飞视觉 end -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.initSwiper();
		},
		methods: {
			/***************** @Events **********************/
			// 点击上一页
			handlePrevClick() {
				this.swiper_instance.slidePrev(300);
			},
			// 点击下一页
			handleNextClick() {
				this.swiper_instance.slideNext(300);
			},
			
			/***************** @Function **********************/
			// 初始化swiper
			initSwiper() {
				this.swiper_instance = new this.Swiper ('.research .swiper-container', {
					loop: false,
					allowTouchMove: false
				});
			},
		}
	}
</script>

<style scoped>
	.research{ position: relative;height: 820px;margin-top: 130px; }
	.research .bg_box{ position: absolute;width: 1920px;height: 820px;top: 0;left: 50%;margin-left: -960px;background-image: url(../../../../assets/technical_support.png);background-size: cover; }
	.research .content_box{ position: relative;width: 1200px;margin: 0 auto;padding: 75px 560px 0 0; }
	.research .title{ font-size: 30px;font-weight: bold;color: #fff;line-height: 42px; }
	.research .en_title{ font-size: 24px;color: #ccc;line-height: 34px; }
	.research .desc{ margin-top: 20px;font-size: 16px;color: #fff;line-height: 30px; }
	.research .swiper_box{ position: relative;height: 120px;margin-top: 174px;padding: 0 28px; }
	.research .prev{ display: block;position: absolute;width: 28px;height: 120px;top: 0;left: 0;background-color: rgba(255, 255, 255, .2);background-image: url(../../../../assets/arrow_left.png);background-position: center center;background-repeat: no-repeat; }
	.research .next{ display: block;position: absolute;width: 28px;height: 120px;top: 0;right: 0;background-color: rgba(255, 255, 255, .2);background-image: url(../../../../assets/arrow_right.png);background-position: center center;background-repeat: no-repeat; }
	.research .prev:hover{ background-color: rgba(255, 255, 255, .8);cursor: pointer; }
	.research .next:hover{ background-color: rgba(255, 255, 255, .8);cursor: pointer; }
	.research .img{ float: left;width: 272px;height: 120px;margin: 0 10px;overflow: hidden; }
	.research .img img{ display: block;width: 100%;height: 100%; }
	
	.research .kf{ position: absolute;width: 440px;height: 787px;top: -52px;right: 0;padding: 120px 67px 0;background-image: url(../../../../assets/kf_bg.png);background-size: cover; }
	.research .kf_img{ height: 210px; }
	.research .kf_img img{ display: block;width: 100%;height: 100%; }
	.research .kf_name{ margin-top: 40px;font-size: 30px;font-weight: bold;color: #0a1c50;line-height: 60px; }
	.research .kf_desc{ margin-top: 6px;color: #0a1c50;line-height: 30px; }
</style>
